import App from './App.svelte'

const app = new App({
	target: document.body,
	props: {
		name: 'FireSvelte - Ready-Collect 🔥'
	}
})

export default app